import { render, staticRenderFns } from "./ItemGroupAvatar.vue?vue&type=template&id=1c63443f&scoped=true&"
import script from "./ItemGroupAvatar.vue?vue&type=script&lang=ts&"
export * from "./ItemGroupAvatar.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c63443f",
  null
  
)

export default component.exports